export class GraphPoint {

    public dateEntered:string;
    public value:number;

}